import api from "@/plugins/api";
/**
 * Calls the BFF global-search endpoint.
 *
 * Hits `GET /api/v1/portal/global-search?query=...&page=...&pageSize=...`. Passing
 * `unwrapEnvelope: true` makes the response interceptor unwrap the `ApiResponse<T>`
 * envelope; the payload is NOT paginated-shaped (no `pagination` object), so
 * `response.data` is the inner `GlobalSearchResult` object directly.
 *
 * The caller passes an `AbortSignal` so stale (raced) requests can be cancelled —
 * cancellation surfaces as a rejected promise the caller filters via `axios.isCancel`.
 */
export async function globalSearch(query, page, pageSize, signal) {
    const response = await api.get("/portal/global-search", {
        params: { query, page, pageSize },
        unwrapEnvelope: true,
        signal,
    });
    return response.data;
}
